import {ScoringSystem} from '@legit.health/ui';
import * as Yup from 'yup';

export function createValidatorForScoringSystem(scoringSystem: ScoringSystem) {
  return Yup.object().shape(
    scoringSystem.items
      .filter((ssitems) => ssitems.question)
      .reduce(
        (acc2, scoringSystemItem) => ({
          ...acc2,
          [scoringSystemItem.id]: Yup.string().required('ui:form.errors.required')
        }),
        {}
      )
  );
}
